import { render, staticRenderFns } from "./MoleculeEditionBillingAcademyClients.vue?vue&type=template&id=5ddf5245"
import script from "./MoleculeEditionBillingAcademyClients.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademyClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports